import "./PageFooter.style.css";

import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AppRouter } from "../../../utils/enums/AppRouter";
import { useIsMobile } from "../../../utils/functions/useIsMobile";
import { getCurrentPage } from "../../../utils/functions/getCurrentPage";
import { Switcher } from "../../base/Switcher/Switcher";
import { ButtonColor, ButtonSize } from "../../base/Button/Button";

import { IconGame36 } from "../../icons/IconGame/IconGame36";
import { IconTools36 } from "../../icons/IconTools/IconTools36";
import { IconUser36 } from "../../icons/IconUser/IconUser36";

const PAGES_WITHOUT_FOOTER_MOBILE = [AppRouter.Game];

export const PageFooter = () => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();

  const handleClickMail = () => {
    navigator.clipboard.writeText("yourdle.fun@gmail.com");
  };

  const path = useLocation().pathname.split("/").slice(1);
  const [currentPage, setCurrentPage] = useState<AppRouter>(
    AppRouter.NotFoundPage,
  );
  const showFooter = !(
    isMobile && PAGES_WITHOUT_FOOTER_MOBILE.includes(currentPage)
  );

  useEffect(() => {
    setCurrentPage(getCurrentPage(path));
  }, [path]);

  return showFooter ? (
    <footer className="footer">
      {isMobile ? (
        <Switcher
          color={ButtonColor.Accent}
          size={ButtonSize.Large}
          items={[
            {
              content: <IconGame36 />,
              onActive: () => navigate(AppRouter.Gallery),
            },
            {
              content: <IconTools36 />,
              onActive: () => navigate(AppRouter.MyGames),
            },
            {
              content: <IconUser36 />,
              onActive: () => navigate(AppRouter.Login),
            },
          ]}
          startingItem={0}
        />
      ) : (
        <div className="footer__text">
          Обнаружили проблему на сайте?
          <br />
          Пожалуйста, напишите нам на{" "}
          <span className="footer__text__mail" onClick={handleClickMail}>
            yourdle.fun@gmail.com
          </span>
          <br />- Yourdle Team 2026
        </div>
      )}
    </footer>
  ) : (
    <></>
  );
};
